import TextEditor from '../TextEditor/TextEditor';

const FormInput = (props) => {
    return (
        <div className="form-group" style={props.style}>
            <label htmlFor={props.id}>{props.label}</label>
            {
                props.type !== 'editor' && <input className='form-control shadow-none' value={props.value} onChange={props.onChange} autoComplete={props.autoComplete} id={props.id} type={props.type} name={props.id} />
            }
            {
                props.type === 'editor' && <div style={{ width: '100%' }} >
                    <TextEditor name={props.id} value={props.value} onChange={props.onChange} />
                </div>
            }
        </div>
    )
}

export default FormInput;